/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const deviceSlice = createSlice({
  name: "deviceSlice",
  initialState: {
    hideBanner: false,
    cartStatus: false,
    membershipStatus: false,
    packageStatus: false,
    // loginStatus: false,
    handShakeStatus: false,
    bookingId: null,
    childId: null,
    drawer: false,
    drawerContent: null,
    drawerTitle: "",
    changePosition:false,
  },
  reducers: {
    hideBannerAction: (state) => {
      state.hideBanner = true;
    },
    setCartStatus: (state, action) => {
      state.cartStatus = action.payload;
    },
    setMembershipStatus: (state, action) => {
      state.membershipStatus = action.payload;
    },
    setPackageStatus: (state, action) => {
      state.packageStatus = action.payload;
    },
    setLoginStatus: (state, action) => {
      state.loginStatus = action.payload;
    },
    drawerAction: (state, action) => {
      state.drawer = action.payload;
    },
    setDrawerContent: (state, action) => {
      state.drawerContent = action.payload;
    },
    setDrawerTitle: (state, action) => {
      state.drawerTitle = action.payload;
    },
    setBookingId: (state, action) => {
      state.bookingId = action.payload;
    },
    setChildId: (state, action) => {
      state.childId = action.payload;
    },
    setPosition: (state, action) => {
      state.changePosition = action.payload;
    },
    setHandShakeStatus: (state, action) => {
      state.handShakeStatus = action.payload;
    },
  },
});
export const {
  hideBannerAction,
  setCartStatus,
  setMembershipStatus,
  setPackageStatus,
  setLoginStatus,
  drawerAction,
  setDrawerContent,
  setDrawerTitle,
  setBookingId,
  setChildId,
  setPosition,
  setHandShakeStatus,
} = deviceSlice.actions;

export default deviceSlice.reducer;
